<template lang="pug">
  .widget-mask
    .widget-wrapper
      .widget-container.frame-center
        div.loader
        iframe#widget.frame-center(:src="getFrameUrl(sid, seid, iid)")
        .close_frame_button#closeFrameBtn(v-if="!isAfishaDomain", @click="closeFrame")
          img(:src="closeIconWhite")
</template>

<script>
import { mapGetters } from 'vuex';
import closeIconWhite from '@/assets/img/closeWhite.svg';
export default {
  model: {
    event: 'change',
  },

  props: {
    sid: {
      type: Number,
      required: true,
    },
    seid: {
      type: Number,
      default: 0,
      required: true,
    },
    iid: {
      type: Number,
      default: 0,
      required: true,
    },
    /* pid: {
      type: Number,
      default: 0,
      required: false,
    }, */
    lang: {
      type: String,
      required: false,
      default: 'ru',
    },
  },

  data() {
    return {
      user: null,
      isAfishaDomain: true,
      frameUrl: {
        'cabinet.guru.ge': 'saleframe.guru.ge',
        'cabinet.24afisha.by': 'saleframe.24afisha.by',
        'cabinet.minskarena.by': 'saleframe.minskarena.by',
        'my.bycard.by': 'saleframe.bycard.by',
        'cabinet.24afisha.arcom.of.by': 'saleframe.arcom.of.by',
      },
      closeIconWhite,
    };
  },

  computed: {
    ...mapGetters({
      getUser: 'getCurrentUser',
    }),
  },

  beforeDestroy() {
    window.removeEventListener('message', this.message);
  },
  deactivated() {
    window.removeEventListener('message', this.message);
  },

  mounted() {
    if (window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
    this.user = this.getUser;
    if (window) {
      window.addEventListener('message', this.message);
    }
  },

  methods: {
    message(msg) {
      if (msg.data && msg.data.action) {
        if (msg.data.action === 'closeFrame') {
          this.$emit('close');
        }
        if (msg.data.action === 'requestToken') {
          const token = this.user && this.user.token ? this.user.token : '';
          const source = document.getElementById('widget').contentWindow;
          source.postMessage({
            action: 'auth',
            token,
          }, this.getFrameOrigin());
        }
        if (msg.data.action === 'closeFrameError') {
          alert(this.$t('msgs.paymentError')); // eslint-disable-line
          this.$emit('close');
        }
      }
    },
    getFrameUrl(sid, seid, iid) {
      const host = `${window.location.protocol}//${this.frameUrl[window.location.hostname] || this.frameUrl['cabinet.24afisha.arcom.of.by']}`;

      if (window && sid && seid && seid > 0) {
        return `${host}?oid=${sid}&seid=${seid}&lang=${this.lang}`;
      }
      if (window && sid && iid && iid > 0) {
        return `${host}/item?oid=${sid}&iid=${iid}&lang=${this.lang}`;
      }
      if (window) {
        return `${host}?sid=${sid}&lang=${this.lang}`;
      }
      return null;
    },

    getFrameOrigin() {
      if (window) {
        return `${window.location.protocol}//${this.frameUrl[window.location.hostname] || this.frameUrl['cabinet.24afisha.arcom.of.by']}`;
      }
      return null;
    },

    closeFrame() {
      const source = document.getElementById('widget').contentWindow;
      if (source) {
        if (source.length > 0) {
          source.postMessage({
            action: 'closeFrameFromSite',
          }, '*');
        } else {
          this.$emit('close');
        }
      }
    },
  },
};
</script>
